import type { z } from 'zod';
import {
    _FindingDtoSchema,
    _SimpleUserDto,
    _SimpleAssetDto,
    _SimpleProviderDto,
} from '@ampsec/platform-client';

type ZodObjectWithShape = z.ZodObject<z.ZodRawShape>;

function getKeysFromZodShape(schema: ZodObjectWithShape): string[] {
    return Object.keys(schema.shape);
}

export type DynamicVariablePaths = {
    finding: string[];
    user: string[];
    asset: string[];
    provider: string[];
};

/**
 * Returns the list of template variable paths per entity, derived from the DTO schemas
 * exported by @ampsec/platform-client. Used by the Dynamic Variables modal.
 * Excludes meta (vendor-specific). Paths are in the form "entity.property".
 */
export function getDynamicVariablePaths(): DynamicVariablePaths {
    const findingKeys = getKeysFromZodShape(_FindingDtoSchema as unknown as ZodObjectWithShape);
    const userKeys = getKeysFromZodShape(_SimpleUserDto as unknown as ZodObjectWithShape);
    const assetKeys = getKeysFromZodShape(_SimpleAssetDto as unknown as ZodObjectWithShape);
    const providerKeys = getKeysFromZodShape(_SimpleProviderDto as unknown as ZodObjectWithShape);

    return {
        finding: findingKeys.map((k) => `finding.${k}`),
        user: userKeys.map((k) => `user.${k}`),
        asset: assetKeys.map((k) => `asset.${k}`),
        provider: providerKeys.map((k) => `provider.${k}`),
    };
}
